// MEMO: selectize動かすのにjqueryのimportが必要
import $ from "jquery";
import "selectize";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja";
import { fadeInOutDuration } from "../variables";

$(() => {
  $(".search__circle--btn").click(() => {
    $(".event-list-sidebar-container").fadeIn(fadeInOutDuration);
    $(".search__circle--btn").fadeToggle(fadeInOutDuration);
    $(".add__circle--btn").fadeToggle(fadeInOutDuration);
    $(".tagfilter-cancel__btn").fadeIn(fadeInOutDuration);
  });

  $(".tagfilter-cancel__btn").click(() => {
    $(".event-list-sidebar-container").fadeToggle(fadeInOutDuration);
    $(".search__circle--btn").fadeIn(fadeInOutDuration);
    $(".add__circle--btn").fadeIn(fadeInOutDuration);
    $(".tagfilter-cancel__btn").fadeToggle(fadeInOutDuration);
  });

  const flatpickrDateConfig = {
    dateFormat: "Y/m/d",
    enableTime: false,
    locale: Japanese,
  };
  flatpickr("#search-start-date", {
    ...flatpickrDateConfig,
  });
  flatpickr("#search-end-date", {
    ...flatpickrDateConfig,
  });
});
